/**
 * Shared normalization for organization id/name used by branding and theme configs.
 */

export function normalizeOrgName(name: string | null | undefined): string | null {
    if (name == null || String(name).trim() === "") return null;
    return String(name).trim().toLowerCase();
}

export function normalizeOrgId(id: string | null | undefined): string | null {
    if (id == null || String(id).trim() === "") return null;
    return String(id).trim();
}
